import React, { useState, useEffect } from "react";
import { api } from "../api";
import { Icon, Modal, Empty, Spinner } from "../components/ui";

/** Opened from the FAQ button in the header. Shows FAQs for the user's role. */
export function FaqViewer({ onClose }) {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.publishedFaqs().then(setRows).catch((e) => { setErr(e.message); setRows([]); });
  }, []);

  return (
    <Modal wide title="FAQ & help" sub="Answers for your access tier" onClose={onClose}>
      {rows === null && <div className="empty"><Spinner /></div>}
      {err && <div className="err-text">{err}</div>}
      {rows && rows.length === 0 && !err && <Empty icon={<Icon.help width="40" height="40" />} title="No FAQs yet" text="Published help content will appear here." />}
      {rows && rows.map((f) => (
        <div className="faq-item" key={f.id}>
          <button className="faq-q" onClick={() => setOpen((o) => (o === f.id ? null : f.id))}>
            {f.question}{f.category && <span className="cat">{f.category}</span>}
          </button>
          {open === f.id && <div className="faq-a">{f.answer}</div>}
        </div>
      ))}
    </Modal>
  );
}
